export const COLOR = {
    GOOGLE_BLUE         : `#4285F4`,
    GOOGLE_BLUE_DARK    : `#61a0bf`,
    GOOGLE_BLUE_LIGHT   : `#1bb6ff`,
    WHITE               : `rgb(255,255,255)`,
    VIOLET              : `#9400d3`,
}
